import styled from 'styled-components';
import { Card, List, Input, Checkbox, Modal, Confirm } from 'semantic-ui-react';

const modalStyles = `
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);

  > .header {
    border-bottom: 1px solid #e8e8e8;
    font-weight: 600;
    padding: 1em 1.5em;
  }

  > .content {
    padding: 1em 1.5em;
  }

  > .actions {
    border-top: 1px solid #e8e8e8;
    padding: 0.75em 1.5em;
  }

  .ui.button {
    border-radius: 8px;
  }

  .ui.input input,
  .ui.form input,
  .ui.form textarea,
  .ui.selection.dropdown {
    border-radius: 20px !important;
  }

  .ui.form textarea {
    padding: 0.8em 1em !important;
  }
`;

export const StyledModal = styled(Modal)`
  &&& {
    ${modalStyles}
  }
`;

export const StyledConfirm = styled(Confirm)`
  &&& {
    ${modalStyles}
  }
`;

export const RoundedCard = styled(Card)`
  &&& {
    border-radius: 20px !important;
    overflow: hidden;
  }
`;

export const CompactList = styled(List)`
  &&& .item {
    padding: 0 !important;
    margin-bottom: 8px;
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    line-height: normal !important;
    transition: box-shadow 0.2s;

    > div {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      width: 100%;
      padding: 8px 10px;
    }

    .task-label {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .due-date {
      white-space: nowrap;
      margin-left: 10px;
      margin-right: 5px;
      font-size: 0.9em;
    }

    &::after {
      display: none !important;
    }

    &:hover {
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
  }
`;

export const CompactInput = styled(Input)`
  margin-bottom: 8px;

  input {
    border-radius: 20px !important;
    background-color: white !important;
    border: 1px solid #e0e0e0 !important;
    padding: 8px 10px !important;
    height: 40px !important;
  }
`;

export const CompactCheckbox = styled(Checkbox)`
  &&& {
    display: flex !important;
    align-items: center !important;
    width: 100%;
    margin-right: 10px;

    label {
      display: flex !important;
      align-items: center !important;
      width: 100%;
      min-height: 20px;
      font-size: 1em;
      text-decoration: ${props => props.checked ? 'line-through' : 'none'};
      color: ${props => props.checked ? '#888' : 'inherit'};
      padding-left: 24px !important;
    }

    label::before {
      top: 50% !important;
      transform: translateY(-50%) !important;
    }

    label::after {
      top: 50% !important;
      transform: translateY(-50%) !important;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding-right: 5px;

  > * {
    margin-left: 8px;
    cursor: pointer;
  }
`;
